import styles from './index.module.scss';
import React, { Fragment, useCallback } from 'react';
import { MenuItemType, SelectInfo } from 'rc-menu/lib/interface';
import Menu, { SubMenu, Item as MenuItem } from 'rc-menu';
import ArrowRight from '../../assets/icon/homeSidebar/arrowRight.svg';
import ArrowRightTop from '../../assets/icon/homeSidebar/arrowRightTop.svg';

export interface MenuItem extends MenuItemType {
  /** 菜单项类型 */
  type?: string;
  /** 菜单项hover时是否需要跳转图标 */
  hideHoverIcon?: boolean;
  /** 子菜单 */
  children?: MenuItem[];
  /** 是否需要分割线 */
  divider?: boolean;
  /** 菜单项渲染节点 */
  title?: React.ReactNode;
  /** 外链 */
  link?: string;
  /** 点击事件 */
  onClick?: (p: MenuItem) => void;
}

/** 菜单组件属性 */
interface CustomMenuProps {
  /** 可以选中 */
  selectable?: boolean;
  /** 菜单项配置 */
  options: MenuItem[];
  /** 默认选中集合 */
  defaultSelectedKeys?: string[];
   /** 点击菜单回调函数 */
  onSelect?: (info: SelectInfo) => void;
}

const MenuDivider = (props: any) => (
  <div className={styles.divider}><div className={styles.line} /></div>
);

const CustomMenu: React.FC<CustomMenuProps> = ({ defaultSelectedKeys = [], options, onSelect, selectable = true }) => {

  /** 渲染菜单项 */
  const renderMenuItems = (items: MenuItem[]) => {
    return items.map((item) => {
      let node = null;

      if (item.children) {
        node = (
          <SubMenu
            expandIcon={<div className={styles.expandIcon}><ArrowRight/></div>}
            key={item.key}
            title={(<>{item.title || ''}</>)}
          >
            {renderMenuItems(item.children)}
          </SubMenu>
        );
      } else {
        node = (
          <MenuItem
            key={item.key}
            disabled={item.disabled}
            className={styles.menuItem}
            onClick={() => item?.onClick?.(item)}
          >
            {item.title}
            {!item.hideHoverIcon && !item.disabled && <div className={styles.hoverIcon}><ArrowRightTop /></div>}
          </MenuItem>
        );
      }
      return (
        <Fragment key={item.key}>
          {node}
          {/* 需要分割线 */}
          {item.divider && <MenuDivider />} 
        </Fragment>
      )
    });
  };

  return (
    <div className={styles.root}>
      <Menu
        selectable={selectable}
        defaultSelectedKeys={defaultSelectedKeys}
        getPopupContainer={triggerNode => triggerNode.parentNode as HTMLElement} // 避免子菜单容器跑到body下
      >
        {renderMenuItems(options)}
      </Menu>
    </div>
  );
};

export default CustomMenu;
